/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'mustache',
  'pip-model',
  'pip-events',
  'pip-common.tooltips'
],
function(
  $,
  Mustache,
  pip,
  pipEvents,
  pipTooltips
){

  var templates = {
    body: '\
    <div id="textAisleBayTooltipBody" class="u__clearfix">\
      {{>bodyHintText}}\
      <label class="b" for="textAisleBayNumber">{{>normalLabel}}</label>\
      <br />\
        <form id="textAisleBayForm">\
          <input type="tel"\
            id="textAisleBayNumberInput"\
            name="textAisleBayNumber"\
            placeholder="___-___-____"\
            class="textAisleBayControl form-input__field strictNumericValidation"\
            maxlength="12" autocomplete="off"\
          />\
          <button type="submit" id="textAisleBayButton" class="textAisleBayControl bttn-outline bttn-outline--dark bttn--inline" href="/p/svcs/taab" rel="nofollow" value="Text Me">\
          <span class="bttn__content">Text Me</span>\
          </button>\
        </form>\
    </div>',
    aisleAndBayBody: '\
      <div id="textAisleBayTooltipBody" class="u__clearfix">\
        <label class="b" for="textAisleBayNumber">{{>normalLabel}}</label>\
        <br />\
        <form id="textAisleBayForm">\
        <input type="tel"\
          id="textAisleBayNumberInput"\
          placeholder="___-___-____"\
          name="textAisleBayNumber"\
          class="textAisleBayControl\
          form-input__field strictNumericValidation"\
          maxlength="12"\
          autocomplete="off"\
        />\
        <button type="submit" id="textAisleBayButton" class="textAisleBayControl bttn-outline bttn-outline--dark bttn--inline" href="/p/svcs/taab" rel="nofollow" value="Text Me"><span class="bttn__content">Text Me</span> </button>\
        </form>\
      </div>',
    bodyHintText: '<span id="bodyHintText">Heading to the store? Enter your phone number, and we\'ll text you where to find this product.<br /><br /></span>',
    aisleAndBayHeader: '\
    <h2 class="aisle-and-bay-tooltip__header tooltip_title">\
      <a class="aisle-and-bay-tooltip__mobile">\
      <svg viewBox="0 0 25 40">\
        <path d="M24.4527279.563498H0v40h24.4527279v-40zM9.9402471 32.327923h4.5702285v4.35069H9.9402471v-4.35069zm10.178781-14.896196v10.856679H4.3336992V4.688922h15.7853289v12 .742805z" fill="#fb6300" fill-rule="evenodd"></path>\
      </svg>\
       </a>\
      <div class="aisle-and-bay-tooltip__header-text">Text Product Location to Your Phone</div>\
        <a class="aisle-and-bay-tooltip__close">\
        <svg viewBox="0 0 32 32">\
          <title>close</title>\
          <path d="M27.229 8.391l-3.385-3.386-7.843 7.838-7.84-7.84-3.386 3.385 7.609 7.608-7.613 7.612 3.385 3.386 7.843-7.838 7.84 7.841 3.387-3.386-7.61-7.608z"></path>\
      </svg>\
      </a>\
    </h2>',
    normalLabel: '<span>Mobile Phone:</span>',
    bodyForSubscribeSavings: '\
      <div id="textAisleBayTooltipBody" class="u__clearfix">\
        <label class="b" for="textAisleBayNumber">{{>normalLabel}}</label>\
        <br />\
        <form id="textAisleBayForm">\
        <input type="tel"\
          id="textAisleBayNumberInput"\
          placeholder="___-___-____"\
          name="textAisleBayNumber"\
          class="textAisleBayControl form-input__field strictNumericValidation"\
          maxlength="12" autocomplete="off"\
        />\
        <button type="submit" id="textAisleBayButton" class="textAisleBayControl bttn-outline bttn-outline--dark bttn--inline" href="/p/svcs/taab" rel="nofollow" value="Text Me"><span class="bttn__content">Text Me</span> </button>\
        <div class="checkbox-btn subscriptionContainer">\
          <input type="checkbox" class="checkbox-btn__input" id="subscriptionAgreement">\
          <label for="subscriptionAgreement" class="checkbox-btn__label subscriptionLabel">\
            Yes, I want <span class="u__bold termsAndConditionsColorText">$5 off my next in store purchase </span> and receive $100s more in savings right to my phone by joining the Home Depot Text Program*\
          </label>\
        </div>\
        </form>\
      </div>',
    errorLabel: '<span class="smartError-color" style="font-size: 12px">Please enter a valid 10-digit phone number.</span>',
    bodyContentsForTextPending: '\
      <div class="textAisleBayPending">\
        <span></span>\
        <img src="https://assets.homedepot-static.com/p/static/images/ajax-loader-orange.gif" />\
      </div>',
    bodyContentsForOptInRequired: '\
      <!-- Include some icon? -->\
      <span>A text message requesting an opt-in to receive in-store product location texts has been sent.</span>',
    bodyContentsForTextSuccess: '\
      <span class="checkMark"></span>\
      <span class="textSucceededMessage">A text message with the product\'s in-store location will arrive shortly. See you soon!</span>',
    bodyContentsForSubscribeSuccess: '\
      <span class="textSucceededSubscribeMessage">\
        <span class="checkMark"></span>\
        <span class="u__bold textAisleBayPending textSucceededSubscribeHeaderText">We\'ll text you shortly</span>\
        <span class="textSucceededSubscribeContent">You\'ll receive a text with product\'s store location from\
        20841 and a text from 65624 to finish signing up for The Home Depot Text Program (and get your\
        <span class="u__bold termsAndConditionsColorText">$5 off coupon</span>)\
        </span>\
      </span>',
    bodyContentsForTextFailure: '\
      <span class="smartError-color b">We\'re sorry. We\'re experiencing technical difficulties. Please try again in a few minutes.</span>',
    footer: '\
      <div class="tooltip_disclaimer">\
        <p>By providing your mobile phone number and clicking "Text Me",\
        you agree to receive in-store product location text messages sent by\
        or on behalf of The Home Depot via automated technology. Consent is not a condition of\
        purchase. Msg&amp;data rates may apply. Not all carriers covered. Message frequency varies\
        based on number of requests. Text <span class="b">STOP</span> to cancel (you will be sent a confirmation message). Text <span class="b">HELP</span>\
        for help. <a href="/c/Privacy_Security">Privacy &amp; Security Statement</a></p>\
      </div>',
    footerForSubscribeSavings: '\
      <div class="termsAndConditionsContainer">\
        <span>\
          By providing your mobile phone number and clicking "Text Me", you agree\
          to receive in-store product location text messages from 20841 sent by or on behalf\
          of The Home Depot via automated technology. Consent is not a condition of purchase.\
          Message frequency varies based on number of requests.\
          Text <span class="u__bold termsAndConditionsColorText">STOP</span> to 20841 to cancel in- store \
          product location alerts (you will be sent a confirmation message).\
          Text <span class="u__bold termsAndConditionsColorText">HELP</span> to 20841 for help.\
        </span>\
        <br/><br/>\
        <span>\
          *By checking the above box and clicking "Text Me", you agree to receive marketing\
          messages from 65624 sent by or on behalf of The Home Depot Text Program\
          via automated technology. Consent is not a condition of purchase.\
          You will receive up to 10 messages/month. \
          <span class="u__bold termsAndConditionsColorText">STOP to 65624 </span> to cancel\
          The Home Depot Text Program (you will be sent a confirmation message).\
          Text <span class="u__bold termsAndConditionsColorText">HELP to 65624 </span>\
          for help. Msg&data rates may apply.\
          <a href="/c/Privacy_Security">Privacy &amp; Security Statement</a>\
        </span>\
      </div>'
  };

  var isSubscribed = false;
  var tooltip = pipTooltips.create({
    callToActionSelector: '#aisleBayTooltipOpener'
  });

  // TODO: Strip all non-digits rather than just hyphens.
  function stripHyphens(phoneNumber) {
    return phoneNumber.replace(/-/g, '');
  }

  function hyphenateNumber(phoneNumber) {
    if (!phoneNumber) {
      return '';
    }

    // TODO: Strip all non-digits rather than just hyphens.
    var updatedPhoneNumber = stripHyphens(phoneNumber);
    if (updatedPhoneNumber.length >= 3) {
      if (updatedPhoneNumber.length >= 6) {
        updatedPhoneNumber = updatedPhoneNumber.substring(0,6) + '-' + (updatedPhoneNumber.length > 6 ? updatedPhoneNumber.substring(6) : '');
      }
      updatedPhoneNumber = updatedPhoneNumber.substring(0,3) + '-' + (updatedPhoneNumber.length > 3 ? updatedPhoneNumber.substring(3) : '');
    }
    return updatedPhoneNumber;
  }

  function handleTooltipOpenerClick(e) {
    e.preventDefault();
    e.stopPropagation();
    displayTooltip();
  }

  // TODO: possible refactor to remove dead function
  function handleTextAisleBayNumberInput(e) {
    var $textAisleBayNumberInput = $(e.target);
    var phoneNumber = $textAisleBayNumberInput.val();
    var updatedPhoneNumber = hyphenateNumber(phoneNumber);
    $textAisleBayNumberInput.val(updatedPhoneNumber);
  }

  function handleTextInput(e) {
    var key = e.keyCode || e.which,
      nonChar = (key == 13 || key === 8 || key === 46 || key === 9 || key === 27 || ((key >= 35) && (key <= 39)) || key === 16 || key === 17 || (key === 65 && e.ctrlKey === true)),
      $this = $(this),
      $getValue = $this.val();

    //check for backspace,delete,tab,escape,home,end,arrows
    if (nonChar) {
      return;
    }

    //make sure they only use numbers
    $getValue = this.value = this.value.replace(/[^0-9\.]|\.+/g, '');
    if ($getValue.length >= 3) {
      var formattedNum = ($getValue.length >= 6) ? $getValue.replace(/^(\d{3})(\d{1,3})/g, "$1-$2-") : $getValue.replace(/^(\d{3})/g, "$1-");
      $this.val(formattedNum);
    }
  }

  var noHyphensPhoneNumberPattern = /^[2-9]\d{2}\d{3}\d{4}/;

  function isValidPhoneNumber(noHyphensPhoneNumber) {
    var isValid = false;
    if (noHyphensPhoneNumber) {
      isValid = noHyphensPhoneNumber.match(noHyphensPhoneNumberPattern);
    }
    return isValid;
  }

  function displayPhoneNumberError() {
    var $textAisleBayForm = $('#textAisleBayForm');
    var $smartErrorColor = $textAisleBayForm.find('.smartError-color');

    if ($smartErrorColor) {
      $smartErrorColor.remove();
    }
    if (pip.features.crmInputAisleAndBayFeatureEnabled) {
      $textAisleBayForm.find('.subscriptionContainer').before(templates.errorLabel);
    } else {
      $textAisleBayForm.append(templates.errorLabel);
    }

    $('#textAisleBayNumberInput').addClass('textAisleBayNumberError');
  }

  // TODO: Optimize element selection.

  function displayRequestPending() {
    // TODO: Move height setting into a separate function.
    var $tooltipBody = $('#textAisleBayTooltipBody');
    var height = $tooltipBody.height();
    $tooltipBody.height(height);
    $tooltipBody.empty();
    $tooltipBody.html(templates.bodyContentsForTextPending);
  }

  // TODO: possible refactor to remove dead function
  function displayOptInRequired() {
    var $tooltipBody = $('#textAisleBayTooltipBody');
    $tooltipBody.html(templates.bodyContentsForOptInRequired);
  }

  function displayTextRequestSucceeded() {
    var $tooltipBody = $('#textAisleBayTooltipBody');

    if (pip.features.crmInputAisleAndBayFeatureEnabled && isSubscribed) {
      $tooltipBody.html(templates.bodyContentsForSubscribeSuccess);
      isSubscribed = false;
    } else {
      $tooltipBody.html(templates.bodyContentsForTextSuccess);
    }
  }

  function displayTextRequestFailed() {
    var $tooltipBody = $('#textAisleBayTooltipBody');
    $tooltipBody.html(templates.bodyContentsForTextFailure);
  }

  function getTextAisleBayRequest(phoneNumber) {
    var primaryItem = pip.products.primary.data;
    var localStore = pip.customer.localStore;

    var textAisleBayInfo = {
      storeID: localStore.storenumber,
      storeAddress: localStore.streetname + ', ' + localStore.cityname + ', ' + localStore.statecode,
      itemName: primaryItem.info.productLabel,
      itemURL: primaryItem.webUrl,
      categoryName: primaryItem.itemExtension.categoryName,
      aisleBay: primaryItem.aisleBay.formatted,
      mdn: phoneNumber,
      isSavingsSubscribed: isSubscribed
    };

    if (pip.features.multistoreFeatureEnabled && pip.nearbyStore && pip.nearbyStore.address) {
      textAisleBayInfo.storeID = pip.nearbyStore.storeId;
      textAisleBayInfo.storeAddress = pip.nearbyStore.address.street + ', ' + pip.nearbyStore.address.city + ', ' + pip.nearbyStore.address.state;
    }

    return textAisleBayInfo;
  }

  function aisleBayTextRequestSucceeded(response) { 
    if (isSubscribed) {
      triggerAnalyticsEvents('aisleAndBayTextMeClickedWithCoupon');
    } else {
      triggerAnalyticsEvents('aisleAndBayTextMeClicked');
    }
    if (response.result === 'opt_in_required') {
      displayTextRequestSucceeded();
    } else if (response.result === 'success') {
      displayTextRequestSucceeded();
    }
  }

  function aisleBayTextRequestFailed(responseError) {
    triggerAnalyticsEvents('aisleAndBayTextMeErrorHappened', responseError);
    displayTextRequestFailed();
    isSubscribed = false;
  }

  // TODO: on keyPress could capture string stripped of all but digits and then on input could repopulate
  // hyphens.
  // Still, doesn't seem to help with backspace and delete as we don't know what was intended to be removed.

  function handleTextAisleBayButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var $textAisleBayNumberInput = $('#textAisleBayNumberInput');
    var phoneNumber = $textAisleBayNumberInput.val();
    // TODO: Strip all non-digits rather than just hyphens.
    var noHyphensPhoneNumber = stripHyphens(phoneNumber);
    // validate
    if (!isValidPhoneNumber(noHyphensPhoneNumber)) {
      displayPhoneNumberError();
      return;
    }
    var textAisleBayRequest = getTextAisleBayRequest(noHyphensPhoneNumber);
    $.ajax('/p/svcs/taab', {
      cache: false,
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(textAisleBayRequest),
      timeout : 10000,
      dataType: 'json',
      method: 'POST'
    })
      .done(aisleBayTextRequestSucceeded)
      .error(aisleBayTextRequestFailed);
    displayRequestPending();
  }

  function setUpEventHandlers() {
    $(document).off('click.textAisleBay').on('click.textAisleBay', '#aisleBayTooltipOpener', handleTooltipOpenerClick);
    $(document).off('submit.textAisleBay').on('submit.textAisleBay', '#textAisleBayForm', handleTextAisleBayButtonClick);
    $(document).off('keyup.textAisleBay blur.textAisleBay').on('keyup blur', '#textAisleBayNumberInput', handleTextInput);
    $(document).off('change.subscriptionAgreement').on('change.subscriptionAgreement', '#subscriptionAgreement', handleCheckboxAgreementClick);
  }

  function handleCheckboxAgreementClick() {
    isSubscribed = $('#subscriptionAgreement').prop('checked');
  }

  function displayTooltip() {
    triggerAnalyticsEvents('aisleAndBayTooltipOpened');

    tooltip.templates.id = 'textAisleBayTooltip';
    tooltip.templates.body = Mustache.to_html(templates.body, {}, templates);

    tooltip.title = 'Text Location to Your Phone';
    tooltip.templates.aisleAndBayHeader = Mustache.to_html(templates.aisleAndBayHeader, {}, templates);
    tooltip.templates.body = Mustache.to_html(templates.aisleAndBayBody, {}, templates);

    tooltip.templates.body = pip.features.crmInputAisleAndBayFeatureEnabled ?
      Mustache.to_html(templates.bodyForSubscribeSavings, {}, templates) :
      Mustache.to_html(templates.body, {}, templates);

    tooltip.templates.footer = pip.features.crmInputAisleAndBayFeatureEnabled ?
      templates.footerForSubscribeSavings :
      templates.footer;

    tooltip.rebuild();
    tooltip.display();

    $('#textAisleBayTooltip.tooltip').addClass('tooltip-header__arrow');
    $('#textAisleBayNumberInput').focus();
  }

  function displayTooltipOpener() {
    $('#aisleBayTooltipOpener').removeClass('hide');
  }

  function triggerAnalyticsEvents(eventName, error) {
    pipEvents.aisleAndBay[eventName].trigger(error);
  }

  return {
    init: function init() {
      // TODO: Consider if these feature switch checks should be moved into app.js.
      var textAisleBayFeature = pip.features.textAisleBayFeature;
      if (!textAisleBayFeature || !textAisleBayFeature.isEnabled) {
        return;
      }

      if (pip.customer.isLocalized) {
        $('#text-aisle-bay-link-container').show();
        setUpEventHandlers();
        displayTooltipOpener();
      }
    }
  };
});

}.call(window));